import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/genres',
  component: mainLayout(loadView('genre/Genre')),
  meta: { requiresAuth: true },
  children: [
    {
      path: ':type/:id/actors',
      name: 'GenreActorList',
      component: loadView('genre/GenreActorList'),
      meta: { requiresAuth: true }
    }
  ]
}
